import { Flex, Typography } from 'front-commons/ds';
import { FlexProps } from 'front-commons/ds/components/Flex/interfaces';
import { IconRotator } from 'hype-ds';

export function ResumeTrigger({
	opacity,
	expanded,
	'data-testid': dataTestId,
}: Partial<Pick<FlexProps, 'opacity'>> & { expanded: boolean; 'data-testid'?: string }) {
	return (
		<Flex data-testid={dataTestId} opacity={opacity} alignItems="center" gap="0">
			<Typography variant="ParagraphSmall/Semibold" color="--text-link">
				Resumo
			</Typography>
			<IconRotator size="16px" name="keyboard_arrow_up" color="--text-link" rotate={expanded} />
		</Flex>
	);
}
